module.exports = {
  ADMIN: 'Admin',
  USER: 'User',
};
